var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manage-entrance",class:{android: !_vm.isIOS}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.entranceName)+"\n  ")]),_c('i',{staticClass:"icon-app_expend_s"})])}
var staticRenderFns = []

export { render, staticRenderFns }